export const REDUCER_KEY = 'campaignDuplicateModal';

const initialDraft = {
    campaignId: '',
    clients: [],
    creatorId: '',
    duplicateBehaviour: null,
};

const initialState = {
    isModalOpen: false,
    loading: false,
    draft: initialDraft,
    errors: {},
    showErrors: false,
    ownOrganization: {},
    organizations: [],
    campaign: {},
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CAMPAIGN_DUPLICATE_MODAL__INIT': {
            return {
                ...state,
                isModalOpen: true,
                loading: true,
                draft: {
                    ...initialDraft,
                },
                errors: {},
                showErrors: false,
            };
        }
        case 'CAMPAIGN_DUPLICATE_MODAL__INIT_SUCCESS': {
            return {
                ...state,
                draft: {
                    ...state.draft,
                    campaignId: action.payload.campaign.id,
                    clients: action.payload.campaign.clients,
                    creatorId: action.payload.creatorId,
                },
                campaign: action.payload.campaign,
                loading: false,
            };
        }
        case 'CAMPAIGN_DUPLICATE_MODAL__INIT_ERROR': {
            return {
                ...state,
                isModalOpen: false,
                loading: false,
            };
        }
        case 'CAMPAIGN_DUPLICATE_MODAL__LOAD_ORGANIZATION': {
            return {
                ...state,
                draft: {
                    ...state.draft,
                },
                ownOrganization: action.payload.ownOrganization,
                organizations: action.payload.organizations,
            };
        }
        case 'CAMPAIGN_DUPLICATE_MODAL__DRAFT_UPDATE': {
            return {
                ...state,
                draft: {
                    ...state.draft,
                    ...action.payload.changes,
                },
            };
        }
        case 'CAMPAIGN_DUPLICATE_MODAL__CONFIRM_START': {
            return {
                ...state,
                loading: true,
                showErrors: false,
            };
        }
        case 'CAMPAIGN_DUPLICATE_MODAL__CONFIRM_END': {
            return {
                ...state,
                loading: false,
                isModalOpen: false,
            };
        }
        case 'CAMPAIGN_DUPLICATE_MODAL__CONFIRM_ERROR': {
            return {
                ...state,
                loading: false,
                showErrors: true,
                errors: action.payload.error,
            };
        }
        case 'CAMPAIGN_DUPLICATE_MODAL__CLOSE_MODAL': {
            return {
                ...state,
                isModalOpen: false,
            };
        }
        default: {
            return state;
        }
    }
};
